import {
  AlertCircle,
  CheckCircle2,
  XCircle,
  TriangleAlert,
  X,
} from "lucide-react";
import { ReactNode, useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

// This is a test line

const getAlertIcon = (
  variant?: "default" | "destructive" | "success" | "info" | "warning" | null
) => {
  switch (variant) {
    case "success":
      return <CheckCircle2 className="h-4 w-4" />;
    case "destructive":
      return <XCircle className="h-4 w-4" />;
    case "warning":
      return <TriangleAlert className="h-4 w-4" />;
    default:
      return <AlertCircle className="h-4 w-4" />;
  }
};

export function CustomAlert({
  message,
  title,
  variant,
  className,
  closeButton,
  onClose,
}: {
  message: ReactNode;
  title?: string;
  variant?:
    | "default"
    | "destructive"
    | "success"
    | "info"
    | "warning"
    | null
    | undefined;
  className?: string;
  closeButton?: boolean;
  onClose?: () => void;
}) {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  if (!visible) return null;

  return (
    <Alert
      variant={variant ? variant : "default"}
      className={cn("relative", className)}
    >
      {getAlertIcon(variant)}
      {closeButton && (
        <button
          type="button"
          onClick={handleClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>
      )}
      {!title && <AlertTitle></AlertTitle>}
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription className={cn(!title && "-mt-1")}>
        {message ? (
          message
        ) : (
          <p>
            No se ha podido cargar la información. Por favor, intente más tarde.
          </p>
        )}
      </AlertDescription>
    </Alert>
  );
}
